import { Link } from "react-router-dom";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  actionLabel?: string;
  actionHref?: string;
  as?: "h1" | "h2";
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  actionLabel,
  actionHref,
  as = "h2",
}: SectionHeadingProps) {
  const Tag = as;
  return (
    <div className="mb-5 flex flex-wrap items-end justify-between gap-3">
      <div>
        {eyebrow ? (
          <p className="flex items-center gap-2 font-label text-[11px] tracking-[0.18em] text-primary-600">
            <span className="h-px w-6 bg-accent-500"></span>
            {eyebrow}
          </p>
        ) : null}
        <Tag className="mt-2 font-heading text-2xl font-black leading-snug text-foreground-950 md:text-[28px]">
          {title}
        </Tag>
        {description ? (
          <p className="mt-1.5 max-w-2xl text-sm leading-relaxed text-foreground-600">{description}</p>
        ) : null}
      </div>
      {actionLabel && actionHref ? (
        <Link
          to={actionHref}
          className="inline-flex items-center gap-1 whitespace-nowrap font-label text-xs text-primary-700 transition-colors hover:text-primary-600"
        >
          {actionLabel}
          <i className="ri-arrow-right-line" aria-hidden="true"></i>
        </Link>
      ) : null}
    </div>
  );
}